import {Component, ChangeDetectionStrategy} from '@angular/core';

import {RouterOutlet} from '@angular/router';
import {FooterComponent} from "./components/footer/footer.component";

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, FooterComponent],
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './app.component.scss'
})
export class AppComponent {
    protected readonly $localize = $localize;
}
